{
  "alert": "Alerte",
  "dismiss": "Rejeter"
}
